import { useEffect, useState } from "react";

const QUERY = "(orientation: landscape)";

const getIsLandscape = (): boolean => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(QUERY).matches;
};

export default function useLandscape(): boolean {
  const [isLandscape, setIsLandscape] = useState<boolean>(getIsLandscape);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }

    const mediaQuery = window.matchMedia(QUERY);
    const handleChange = (event: MediaQueryListEvent) => {
      setIsLandscape(event.matches);
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return isLandscape;
}